import type { OrderCreationSectionId } from '../constants';

/**
 * The `customer` and `content` section titles were deduplicated into `common.json` (their text
 * matched a generic label elsewhere) — those resolve via the caller's `tCommon`. Every other
 * section title still translates via `sections.<id>.title` in the local `order-creation`-bound `t`.
 */
const ORDER_CREATION_SECTION_TITLE_COMMON_KEY_OVERRIDES: Partial<Record<OrderCreationSectionId, string>> = {
  content: 'fields.content',
  customer: 'fields.customer',
};

/** Resolves a section's title, reading the deduplicated few from `tCommon` and the rest from `t`. */
export function resolveOrderCreationSectionTitle(
  id: OrderCreationSectionId,
  t: (key: string) => string,
  tCommon: (key: string) => string,
): string {
  const commonKey = ORDER_CREATION_SECTION_TITLE_COMMON_KEY_OVERRIDES[id];
  return commonKey ? tCommon(commonKey) : t(`sections.${id}.title`);
}
